import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { FeaturedProjects } from "./components/featuredprojects";
import { Gallery } from "./components/gallery";
import { ProjectDetail } from "./components/projectdetail";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
  };

  const handleBackToGallery = () => {
    setSelectedProject(null);
  };

  if (selectedProject) {
    return <ProjectDetail project={selectedProject} onBack={handleBackToGallery} />;
  }

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <FeaturedProjects data={landingPageData.FeaturedProjects} />
      {landingPageData.Gallery?.enabled && <Gallery data={landingPageData.Gallery} onProjectSelect={handleProjectSelect} />}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
